/* This is the EMIS last student for primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + lastacc + ' និងសិស្សអាហារូបករណ៍'"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 170px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សិស្ស
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ២</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៦</td>
            <td class="row-header" colspan="2">សរុប</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in d2.length - lastRow" :key="row">
            <!-- This is data coloumn -->
            <td v-if="row < 4 || row == 5" class="td-title">{{ d2[row] + " " + lastacc }}</td>
            <td v-if="row == 4 || row == 6" class="td-title">{{ d2[row] + " " + curacc }}</td>
            <td v-if="row == 7" class="td-title">{{ d2[row]}}</td>
            <td v-for="(value, col) in data[row].dt.length" :key="col" :class="[!onOff[row][col] ? 'row-data-gray' : 'row-data']">
              <numberinput v-model="data[row].dt[col]" :disabled="!onOff[row][col]" class="number"/>
            </td>
            <!-- This is total column -->
            <td class="row-data">
              <strong>{{ row1[row] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row2[row] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { d2, lstStuOnOff } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "curacc", "lastacc", "cur_cod", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d2: d2,
      onOff: lstStuOnOff,
    };
  },
  computed: {
    // Compute function for re-entry program
    row1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    //variable control the last added row of 20-21
    lastRow: function () {
      if (this.cur_cod > 12) return 0;
      else return 1;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 45px;
  text-align: center;
}
.td-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-data {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>